import { PatientsListColumnName } from '@/shared/config';

// URL search parameters each header filter writes. The filter dropdowns own
// these names; keep this list in sync with features/*DropdownFilter.
export const getColumnFilterParams = (
  column: PatientsListColumnName,
): string[] => {
  switch (column) {
    case PatientsListColumnName.Doctors:
      return ['doctorIDs'];

    case PatientsListColumnName.DateOfBirth:
      return ['ageGroup'];

    case PatientsListColumnName.Studies:
      return ['studyTypes', 'hasTranscriptor', 'reportTypes'];

    case PatientsListColumnName.LastModified:
      return ['lastModifiedFrom', 'lastModifiedTo', 'lastModifiedPeriod'];

    default:
      return [];
  }
};
